<template>
    <v-chip-group>
        <v-chip v-for="area in shapedAreas" :key="area._id" small :color="area.color" text-color="white" class="rounded-0">{{ area.name }}</v-chip>
    </v-chip-group>
</template>

<script>
export default {
    props: ["areas"],
    computed: {
        parentAreas() {
            return this.$store.state.areas.filter(({ _parent }) => !_parent);
        },
        sortedAreas() {
            return this.parentAreas.reduce((areas, { _id }) => [...areas, ...this.areas.filter(({ _parent }) => _parent == _id)], []);
        },
        shapedAreas() {
            return this.sortedAreas.map((area) => {
                let color = "grey";
                if (area.parent.name == "하드웨어개발") color = "blue darken-4";
                if (area.parent.name == "시제품제작") color = "blue";
                if (area.parent.name == "소프트웨어개발") color = "primary darken-4";
                if (area.parent.name == "제품실증") color = "green darken-2";

                let { name } = area;
                if (name == "기타(입력)") name = "기타";

                return { ...area, name, color };
            });
        },
    },
};
</script>
